import { InputLabel, TextField, TextFieldProps } from "@material-ui/core"
import React from "react"
import { Divider } from "@/components/index"
import useCustomStyles from "@/styles/custom"

const CustomTextField = (props: TextFieldProps) => {
	const customClasses = useCustomStyles()
	const hasFloatingLabel = Boolean(props.label)

	return <div>
		{!hasFloatingLabel && (
			<React.Fragment>
				<InputLabel
					className={customClasses.inputLabel}
				>
					{props.placeholder}
				</InputLabel>

				<Divider orientation="horizontal" size={1} />
			</React.Fragment>
		)}

		<TextField
			InputLabelProps={hasFloatingLabel ? { className: customClasses.floatingInputLabel } : undefined}
			{...props}
		/>
	</div>
}

export default CustomTextField
